import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Organisme, OrganismeAPI } from '../models/organisme';

@Injectable({
  providedIn: 'root'
})
export class OrganismeService {

  constructor() { }

  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  pullDetail(id: number): Observable<Organisme> {
    const headers = this.getHeaders();

    return this.http
      .get<OrganismeAPI>(`${environment.api.gateway}organismes/${id}`, {
        headers,
      })
      .pipe(map((patient: OrganismeAPI) => Organisme.factory(patient)));
  }

}
